import PropTypes from "prop-types";
import { LeagueStructureProvider } from "./StructureProvider";
import Manager from "./Manager"

function Simulator({ league, language }) {
	
  return (
    <LeagueStructureProvider>
			<Manager language={language}/>
    </LeagueStructureProvider>
  );
}

Simulator.propTypes = {
  league: PropTypes.string,
  language: PropTypes.string.isRequired,
};

export default Simulator;